import { render, staticRenderFns } from "./DataTable.vue?vue&type=template&id=8930cc32&scoped=true"
import script from "./DataTable.vue?vue&type=script&lang=js"
export * from "./DataTable.vue?vue&type=script&lang=js"
import style0 from "./DataTable.vue?vue&type=style&index=0&id=8930cc32&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8930cc32",
  null
  
)

export default component.exports